// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirmation_mail_title {\n  font: bold normal 22px;\n  color: var(--primary-color);\n}\n\n.input-mail {\n  font: normal 14px;\n  padding: 20px 0;\n}\n.button-container {\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n}", ""]);
// Exports
module.exports = exports;
